<template>
    <div class="mit-app-menu">
          <v-navigation-drawer app permanent clipped>
            <MitMenu v-if="userModel" :userModel="userModel" :userRoles="userRoles" v-on:logout="logout" v-on:login="login"/>
          </v-navigation-drawer>
      </div>
</template>

<script>
import MitMenu from './MitMenu.vue';

export default {
  name: 'MitAppMenu',
  components: {
    MitMenu
  },
  props: {
    userModel: Object,
    userRoles: Object
  },
  data: function() {
    return {
    }
  },
  methods : {
        login(){
          this.$emit('login');
        },
        logout: function() {
          this.$emit('logout');
        }
  }
}
</script>

<style lang="scss" scoped>
</style>
